import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function ServerLinux() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const linuxDistributions = [
        "Ubuntu Server (LTS)",
        "CentOS / Rocky Linux",
        "Debian",
        "Red Hat Enterprise Linux",
        "Amazon Linux",
        "SUSE Linux Enterprise"
    ];

    const webServices = [
        "Apache HTTP Server",
        "Nginx",
        "PHP (tutte le versioni)",
        "MySQL / MariaDB",
        "PostgreSQL",
        "Redis",
        "Elasticsearch",
        "Node.js"
    ];

    const securityFeatures = [
        "Configurazione firewall (iptables/ufw)",
        "Fail2ban per protezione brute force",
        "SSL/TLS con Let's Encrypt",
        "Aggiornamenti automatici di sicurezza",
        "Backup criptati",
        "Monitoraggio accessi SSH",
        "Hardening sistema",
        "Audit di sicurezza periodici"
    ];

    const monitoringFeatures = [
        "Monitoraggio CPU, RAM, Disk",
        "Controllo servizi critici",
        "Log analysis in tempo reale",
        "Allerte automatiche",
        "Dashboard Grafana",
        "Metriche Prometheus",
        "Report performance mensili",
        "Notifiche email/Telegram"
    ];

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Amministrazione Server Linux</h1>
                    <p className="service-description">
                        Gestione professionale di server Linux con tutte le principali distribuzioni,
                        monitoraggio 24/7 e supporto specializzato per ambienti enterprise.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={8}>
                            <div className="service-description">
                                <h3>Amministrazione Server Linux Professionale</h3>
                                <p>
                                    Sono specializzato nella gestione di server Linux con anni di esperienza
                                    su tutte le principali distribuzioni. Garantisco massime prestazioni,
                                    sicurezza e disponibilità per i tuoi servizi critici.
                                </p>
                                <p>
                                    Dalla configurazione iniziale alla manutenzione avanzata,
                                    gestisco ogni aspetto dell'infrastruttura Linux con competenza
                                    e professionalità, utilizzando le migliori pratiche del settore.
                                </p>
                            </div>

                            <div className="linux-distributions">
                                <h3>Distribuzioni Linux Supportate</h3>
                                <Row>
                                    {linuxDistributions.map((distro, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🐧</span>
                                                {distro}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="web-services-section">
                                <h3>Servizi Web e Database</h3>
                                <Row>
                                    {webServices.map((service, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">⚙️</span>
                                                {service}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <Alert variant="success" className="linux-alert">
                                <h5><i className="fab fa-linux"></i> Ottimizzazione Prestazioni</h5>
                                <p>
                                    Configuro e ottimizo il kernel Linux per massimizzare le prestazioni
                                    in base al carico di lavoro specifico del tuo server.
                                </p>
                            </Alert>

                            <div className="security-section">
                                <h3>Sicurezza e Hardening</h3>
                                <Row>
                                    {securityFeatures.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🔒</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="monitoring-section">
                                <h3>Sistema di Monitoraggio Avanzato</h3>
                                <Row>
                                    {monitoringFeatures.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">📊</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Processo di Gestione</h3>
                                <div className="process-steps">
                                    <div className="process-step-item">
                                        <div className="step-number">1</div>
                                        <div className="step-text">Audit iniziale e analisi configurazione esistente</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">2</div>
                                        <div className="step-text">Hardening di sicurezza e ottimizzazione</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">3</div>
                                        <div className="step-text">Implementazione monitoring e backup automatici</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">4</div>
                                        <div className="step-text">Manutenzione proattiva e supporto continuo</div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Piani Linux</h4>
                                        <div className="pricing-plan">
                                            <h5>Linux Basic</h5>
                                            {/* <div className="plan-price">€120/mese</div> */}
                                            <ul>
                                                <li>1 Server Linux</li>
                                                <li>Monitoraggio base</li>
                                                <li>Backup settimanali</li>
                                                <li>Supporto 9-18</li>
                                                <li>Updates automatici</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan featured">
                                            <h5>Linux Professional</h5>
                                            {/* <div className="plan-price">€250/mese</div> */}
                                            <ul>
                                                <li>Fino a 3 Server</li>
                                                <li>Monitoraggio 24/7</li>
                                                <li>Backup giornalieri</li>
                                                <li>Supporto prioritario</li>
                                                <li>Dashboard Grafana</li>
                                                <li>Performance tuning</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan">
                                            <h5>Linux Enterprise</h5>
                                            {/* <div className="plan-price">€450/mese</div> */}
                                            <ul>
                                                <li>Server illimitati</li>
                                                <li>Cluster management</li>
                                                <li>Load balancing</li>
                                                <li>Disaster recovery</li>
                                                <li>SLA 99.9%</li>
                                                <li>Supporto H24</li>
                                            </ul>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card className="linux-features-card">
                                    <Card.Body>
                                        <h4>🚀 Specializzazioni Linux</h4>
                                        <ul>
                                            <li>Docker & Kubernetes</li>
                                            <li>Load Balancer (HAProxy)</li>
                                            <li>Cluster MongoDB/MySQL</li>
                                            <li>CI/CD con GitLab</li>
                                            <li>Elasticsearch Stack</li>
                                            <li>Reverse Proxy Nginx</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <a href="#contact" className="btn-gradient w-100 mb-3">
                                        <span>Richiedi Preventivo Linux</span>
                                    </a>
                                    <Link to="/services" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
            </Container>
        </div>
    );
}

export default ServerLinux;